import React from 'react';
import { Link } from 'react-router-dom';
import features01 from '../../assets/img/features/mission-img.png';
import features02 from '../../assets/img/features/vision-img.png';

const sections = [
    {
        imgSrc: features01,
        title: 'Our Mission',
        buttonText: 'learn more',
    },
    {
        imgSrc: features02,
        title: 'Our Vision',
        buttonText: 'get in touch',
    },
];

function Mission() {
    return (
        <>
            <section className="mission-area pb-90 p-relative">
                <div className="container">
                    <div className="row">
                        {sections.map((section, index) => (
                            <div className="col-lg-6 col-md-12" key={index}>
                                <div className="mission-box mb-30">
                                    <img src={section.imgSrc} alt="img" />
                                    <div className="text">
                                        <div className="title">
                                            <h3>{section.title}</h3>
                                            <p>
                                                We are open to suggestion and very flexible when it comes to digital photography
                                            </p>
                                        </div>
                                        <Link to="/contact" className="btn ss-btn" data-animation="fadeInUp" data-delay=".4s">
                                            <i className="fas fa-angle-right" /> {section.buttonText}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Mission;
